<!-- 快捷键配置操作 -->
<template>
   <div class="store-modal-content">
      <div class="data_action_form">
         <el-card class="box-card" body-style="padding:20px;border:1px solid #E4E7ED">
            <div class="table_content_box">
               <!-- 快捷键配置表单 -->
               <el-form size="mini" :model="sendDataInfo" label-width="120px" ref="sendDataInfo" :rules="formRules" :show-message="true">
                  <el-row :gutter="20">
                     <el-col :span="12">
                        <el-form-item label="按键组名称" prop="groupName">
                           <el-input v-model.trim="sendDataInfo.groupName" :maxlength="50" placeholder="请输入按键组名称" :disabled="actionData.cate === 1"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :span="12">
                        <el-form-item label="按键组关键字" prop="groupKey">
                           <el-input v-model.trim="sendDataInfo.groupKey" :maxlength="20" placeholder="请输入按键组关键字" :disabled="actionData.cate === 1"></el-input>
                        </el-form-item>
                     </el-col>
                  </el-row>

                  <el-row :gutter="20">
                     <el-col :span="12">
                        <el-form-item label="功能按键" prop="functionKey">
                           <el-select v-model="sendDataInfo.functionKey" placeholder="请选择功能按键" clearable style="width: 100%">
                              <el-option label="无" :value="null"></el-option>
                              <el-option label="Ctrl" value="ctrlKey"></el-option>
                              <el-option label="Shift" value="shiftKey"></el-option>
                              <el-option label="Alt" value="altKey"></el-option>
                           </el-select>
                        </el-form-item>
                     </el-col>
                     <el-col :span="12">
                        <el-form-item label="实际按键" prop="workKey">
                           <el-input v-model.trim="sendDataInfo.workKey" :maxlength="10" placeholder="请输入实际按键" @keydown.native="captureKey"></el-input>
                           <div class="form-tip">提示：可以直接按键自动填入</div>
                        </el-form-item>
                     </el-col>
                  </el-row>

                  <el-row :gutter="20">
                     <el-col :span="12">
                        <el-form-item label="展示标识" prop="showName">
                           <el-input v-model.trim="sendDataInfo.showName" :maxlength="20" placeholder="请输入展示标识"></el-input>
                           <div class="form-tip">如：F1、Ctrl+S、Shift+F4等</div>
                        </el-form-item>
                     </el-col>
                     <el-col :span="12">
                        <el-form-item label="状态" prop="state">
                           <el-select v-model="sendDataInfo.state" placeholder="请选择状态" clearable style="width: 100%">
                              <el-option label="启用" :value="1"></el-option>
                              <el-option label="禁用" :value="0"></el-option>
                           </el-select>
                        </el-form-item>
                     </el-col>
                  </el-row>

               </el-form>
            </div>

         </el-card>
      </div>
      <div class="dialog-footer">
         <el-button @click="cancelAction">取 消</el-button>
         <el-button type="primary" @click="submitAction()"> {{ actionData.cate === 0 ? '新增' : '保存' }}</el-button>
      </div>

   </div>
</template>

<script>
export default {
   name: 'getKeyQueryModal',
   props: {
      actionData: {
         type: Object,
         default: () => ({})
      }
   },
   data() {
      return {

         sendDataInfo: {
            id: '',
            groupName: '',
            groupKey: '',
            functionKey: null,
            workKey: '',
            showName: '',
            isEnabled: true,
            remark: ''
         },
         formRules: {
            groupName: [
               { required: true, message: '请输入按键组名称', trigger: 'blur' },
               { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
            ],
            groupKey: [
               { required: true, message: '请输入按键组关键字', trigger: 'blur' },
               { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' },
               { pattern: /^[A-Z_]+$/, message: '只能包含大写字母和下划线', trigger: 'blur' }
            ],
            workKey: [
               { required: true, message: '请输入实际按键', trigger: 'blur' },
               { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
            ],
            showName: [
               { required: true, message: '请输入展示标识', trigger: 'blur' },
               { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
            ]
         }
      }
   },
   watch: {
      actionData: {
         handler(newVal) {
            if (newVal && newVal.oldData) {
               // 编辑模式，填充数据
               this.sendDataInfo = {
                  ...this.sendDataInfo,
                  ...newVal.oldData
               }
            } else {
               // 新增模式，重置数据
               this.resetForm()
            }
         },
         immediate: true,
         deep: true
      },
      // 监听功能按键和实际按键变化，自动生成展示标识
      'sendDataInfo.functionKey': {
         handler() {
            this.generateShowName()
         }
      },
      'sendDataInfo.workKey': {
         handler() {
            this.generateShowName()
         }
      }
   },
   methods: {
      // 捕获按键
      captureKey(event) {
         event.preventDefault()
         event.stopPropagation()

         let key = event.key

         // 处理特殊按键
         if (key === ' ') key = 'Space'
         if (key === 'Control') key = 'Ctrl'
         if (key === 'Escape') key = 'Esc'

         this.sendDataInfo.workKey = key

         // 自动设置功能键
         if (event.ctrlKey && key !== 'Ctrl') {
            this.sendDataInfo.functionKey = 'ctrlKey'
         } else if (event.shiftKey && key !== 'Shift') {
            this.sendDataInfo.functionKey = 'shiftKey'
         } else if (event.altKey && key !== 'Alt') {
            this.sendDataInfo.functionKey = 'altKey'
         }
      },

      // 自动生成展示标识
      generateShowName() {
         const { functionKey, workKey } = this.sendDataInfo

         if (!workKey) {
            this.sendDataInfo.showName = ''
            return
         }

         let showName = workKey

         if (functionKey) {
            const keyMap = {
               'ctrlKey': 'Ctrl',
               'shiftKey': 'Shift',
               'altKey': 'Alt'
            }
            showName = `${keyMap[functionKey]}+${workKey}`
         }

         this.sendDataInfo.showName = showName
      },

      // 重置表单
      resetForm() {
         this.sendDataInfo = {
            id: '',
            groupName: '',
            groupKey: '',
            functionKey: null,
            workKey: '',
            showName: '',
            isEnabled: true,
            remark: ''
         }

         if (this.$refs.sendDataInfo) {
            this.$refs.sendDataInfo.clearValidate()
         }
      },

      // 取消操作
      cancelAction() {
         this.$emit('drawerCancel', false)
      },

      // 提交操作
      async submitAction() {
         try {
            // 表单验证
            await this.$refs.sendDataInfo.validate()



            // 准备提交数据
            const submitData = { ...this.sendDataInfo }

            // 调用API
            let response
            if (this.actionData.cate === 0) {
               // 新增
               //  response = await this.$http.cashdeskUpdateKeyMap(submitData)
            } else {
               // 编辑
               response = await this.$http.cashdeskUpdateKeyMap(submitData)
            }

            if (response.status === 200) {
               this.$message.success(this.actionData.cate === 0 ? '新增成功' : '保存成功')
               this.$emit('drawerCancel', true) // 传true表示需要刷新列表
            } else {
               this.$message.error(response.message || '操作失败')
            }
         } catch (error) {
            console.error('表单验证失败:', error)
         } finally {

         }
      }
   }
}
</script>

<style scoped>
.store-modal-content {
   width: 100%;
}

.form-tip {
   font-size: 12px;
   color: #909399;
   margin-top: 4px;
}

.form-actions {
   text-align: center;
   margin-top: 20px;
   padding-top: 20px;
   border-top: 1px solid #ebeef5;
}

.form-actions .el-button {
   margin: 0 10px;
   min-width: 80px;
}

.box-card {
   border-radius: 8px;
   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

::v-deep .el-form-item__label {
   font-weight: 500;
   color: #606266;
}

::v-deep .el-input__inner {
   border-radius: 4px;
}

::v-deep .el-textarea__inner {
   border-radius: 4px;
}

::v-deep .el-select .el-input__inner {
   border-radius: 4px;
}
.dialog-footer {
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   background: #fff;
   height: 46px;
   padding: 5px 10px;
   margin-top: 20px;
   border-top: 1px solid #eee;
}
</style>
